/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Activity_BriefedInputs */

const en_landing_preview_activity_briefed = /** @type {(inputs: Landing_Preview_Activity_BriefedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sent morning briefing to 3 desks`)
};

/**
* | output |
* | --- |
* | "sent morning briefing to 3 desks" |
*
* @param {Landing_Preview_Activity_BriefedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_activity_briefed = /** @type {((inputs?: Landing_Preview_Activity_BriefedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Activity_BriefedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_activity_briefed(inputs)
});